import { IconButton, makeStyles } from '@material-ui/core'
import { FilterChip } from 'asterX-UI/Inputs'
import React, { useState, useEffect } from 'react'
import { FilterSimplifiedIcon } from 'asterX-UI/Icons'
import { GRAY_COLORS } from 'asterX-UI'
import { Modal } from 'asterX-UI/Modals'

import TireFilterDialog from 'pages/Mobile/Selection/Manager/components/FilterPanel/TireFilterDialog'
import { TireService } from 'lib/api/services/TireService'
import { useTireFilterStore } from 'context/SelectionStore/Manager/TireFilterStoreContext'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    display: 'flex',
    overflowX: 'auto',
    gap: 6,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    },
    marginTop: 8
  }
}))

const TireFilterPanel = () => {
  const {
    store: { filter },
    func: { onChangeFilterChip }
  } = useTireFilterStore()
  const classes = useStyle()
  const maxWidth = window.innerWidth - 16
  const [isFilterFullOpen, setIsFilterFullOpen] = useState(false)
  const [brands, setBrands] = useState([])
  console.log('brands', brands)
  useEffect(() => {
    const fetchMarks = async () => {
      const res = await TireService.getMarks()
      setBrands(res.data || [])
    }
    fetchMarks()
  }, [])

  const onChange = e => {
    const { name, value } = e.target
    if (name === 'studs') {
      if (value) {
        onChangeFilterChip({ studs: value, season: 'Зима шипы' })
        return
      }
    }

    onChangeFilterChip({ [name]: value })
  }

  const onChangeRange = e => {
    const { name, value } = e.target
    switch (name) {
      case 'radius':
        return onChangeFilterChip({
          radiusFrom: value?.min,
          radiusTo: value?.max
        })
      case 'height':
        return onChangeFilterChip({
          heightFrom: value?.min,
          heightTo: value?.max
        })
      case 'width':
        return onChangeFilterChip({
          widthFrom: value?.min,
          widthTo: value?.max
        })
      default:
        return
    }
  }

  return (
    <div className={classes.rootDiv} style={{ maxWidth }}>
      <IconButton
        style={{ color: GRAY_COLORS['700'] }}
        onClick={() => setIsFilterFullOpen(true)}
        size={'small'}
      >
        <FilterSimplifiedIcon />
      </IconButton>

      <FilterChip
        type={'INPUT'}
        label={'ID Комплекта'}
        value={filter.id}
        name={'id'}
        textType={'number'}
        onChange={onChange}
      />

      <FilterChip
        type={'RANGE'}
        label={'Диаметр'}
        value={{ min: filter?.radiusFrom, max: filter?.radiusTo }}
        onChange={onChangeRange}
        name={'radius'}
        rangeLabel={['От', 'До']}
      />

      <FilterChip
        type={'RANGE'}
        label={'Высота'}
        value={{ min: filter?.heightFrom, max: filter?.heightTo }}
        onChange={onChangeRange}
        name={'height'}
        rangeLabel={['От', 'До']}
      />

      <FilterChip
        type={'RANGE'}
        label={'Ширина'}
        value={{ min: filter?.widthFrom, max: filter?.widthTo }}
        onChange={onChangeRange}
        name={'width'}
        rangeLabel={['От', 'До']}
      />

      <FilterChip
        type={'SELECT'}
        label={'Сезонность'}
        name={'season'}
        valueKey={null}
        labelKey={null}
        options={['Всесезонная', 'Зима шипы', 'Лето', 'Зима липучка']}
        value={filter?.season}
        onChange={onChange}
      />

      <FilterChip
        type={'SELECT'}
        label={'Бренд'}
        name={'mark'}
        valueKey={'id'}
        labelKey={'name'}
        options={brands}
        value={filter?.mark}
        onChange={onChange}
      />

      <FilterChip
        type={'SELECT'}
        label={'Диски'}
        name={'hasRims'}
        options={[true, false]}
        value={filter?.hasRims}
        onChange={onChange}
      />

      <Modal
        fullWidth
        maxWidth={'md'}
        open={isFilterFullOpen}
        onClose={() => setIsFilterFullOpen(false)}
      >
        <TireFilterDialog setIsFilterFullOpen={setIsFilterFullOpen} />
      </Modal>
    </div>
  )
}

export default TireFilterPanel
